// extracted by mini-css-extract-plugin
module.exports = {"logo":"DonationPaymentsTable_logo__2M3b5"};